import { render, staticRenderFns } from "./MspTestDetail.vue?vue&type=template&id=f81dd844"
import script from "./MspTestDetail.vue?vue&type=script&lang=js"
export * from "./MspTestDetail.vue?vue&type=script&lang=js"
import style0 from "./MspTestDetail.vue?vue&type=style&index=0&id=f81dd844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports